"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ChildToParentLimitExceededError extends client_library_1.ExtendableError {
    constructor() {
        super('Child to parent limit has been exceeded');
    }
}
exports.default = ChildToParentLimitExceededError;
//# sourceMappingURL=ChildToParentLimitExceededError.js.map